export default __webpack_public_path__ + "static/media/Dvbbh3bt.2559f3d4.ttf";